import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import BaseIcon from "../../../../components/BaseIcon";
import BaseDivideLine from "../../../../components/BaseDivideLine";
import BaseButton from "../../../../components/BaseButton";
import useModalActions from "../../../../hooks/useModalActions";
import { MODAL_TYPES } from "../../../../utils/emitter";
import ROUTES from "../../../../utils/routes";
import "./style.scss";

// 7-я зона «Личные запросы» (Этап 2): заполненные индивидуальные (BLANK) анкеты.
// item.cards — элементы zonePersonal с бэка: { pairKey, insightFormId, customTitle,
// status, bothFilled, createdAt }. Зона изначально пустая — показываем описание
// и кнопку ПОДРОБНЕЕ (длинный текст «Что такое чистая анкета?»).
export default observer(function ZonePersonal({ item }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { openModal } = useModalActions();
  const { cards, title, texts, icon_name, key } = item;

  const openForm = (form) => {
    if (form.bothFilled) {
      navigate(ROUTES.HISTORY_INSIGHT_QUESTIONNAIRE_FORM_PAGE(form.insightFormId), {
        state: { formId: form.insightFormId },
      });
    } else {
      navigate(ROUTES.INSIGHT_QUESTIONNAIRE_FORM_PAGE(form.insightFormId), {
        state: { formId: form.insightFormId },
      });
    }
  };

  return (
    <div className="item-zone zone-personal" id={`zone-${key}`}>
      <div className="item-zone__header">
        <div className="item-zone__header-left">
          <div className="item-zone__icons">
            <BaseIcon name={icon_name} />
          </div>
          <div className="item-zone__title">
            <div>{t(title)}</div>
            <div>
              {t("demo_result_test_page.zone_7.count", {
                count: cards.length,
              })}
            </div>
          </div>
        </div>
      </div>
      <div className="item-zone__content">
        {cards.length ? (
          <div className="zone-personal__forms">
            {cards.map((form) => (
              <button
                type="button"
                key={form.pairKey || form.insightFormId}
                className={[
                  "zone-personal__form",
                  form.bothFilled ? "zone-personal__form--filled" : "",
                ].join(" ")}
                onClick={() => openForm(form)}
              >
                <span className="zone-personal__form-title">
                  {form.customTitle}
                </span>
                <span className="zone-personal__form-status">
                  {form.bothFilled
                    ? t("demo_result_test_page.zone_7.filled")
                    : t("demo_result_test_page.zone_7.waiting")}
                </span>
              </button>
            ))}
          </div>
        ) : null}
        <div className="item-zone__texts zone-personal__texts">
          {texts.map((text, index) => (
            <div key={index} className="item-zone__text">
              {t(text)}
            </div>
          ))}
        </div>
        <div className="zone-personal__details">
          <BaseButton
            onClick={() => openModal(MODAL_TYPES.BLANK_FORM_DETAILS)}
            className="zone-personal__details-button"
          >
            {t("blank_form.details_btn")}
          </BaseButton>
        </div>
      </div>
      <BaseDivideLine dash />
    </div>
  );
});
